<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    :pagination.sync="internalPagination"
    :rows-per-page-items="[10, 20, 50, 100]"
    :total-items="pagination.totalItems"
    class="user-actions-table"
  >
    <template v-slot:no-data>
      <v-alert :value="true" color="info" icon="info" outline>
        No hay informacion con los filtros seleccionados
      </v-alert>
    </template>

    <template v-slot:items="props">
      <tr>
        <td>
          <div class="font-weight-medium">{{ props.item.name }}</div>
        </td>
        <td>{{ props.item.email }}</td>
        <td>
          <template v-if="props.item.roles && props.item.roles.length">
            <v-chip
              v-for="role in props.item.roles"
              :key="`${props.item.id}-${role}`"
              small
              label
              class="ma-1"
            >
              {{ roleLabel(role) }}
            </v-chip>
          </template>
          <span v-else class="grey--text">-</span>
        </td>
        <td>{{ companiesText(props.item.companies) }}</td>
        <td>{{ formatDate(props.item.created_at) }}</td>

        <!-- Onboarding progress -->
        <td class="progress-cell">
          <template
            v-if="props.item.progress_onboarding && props.item.progress_onboarding.total > 0"
          >
            <div class="caption mb-1">
              {{ props.item.progress_onboarding.done }}/{{ props.item.progress_onboarding.total }}
            </div>
            <v-progress-linear
              :value="props.item.progress_onboarding.percentage"
              height="8"
              color="primary"
              background-color="grey lighten-2"
            ></v-progress-linear>
          </template>
          <span v-else class="grey--text">-</span>
        </td>

        <td>
          <user-action-status-chip
            :status="props.item.status"
            :label="props.item.status_label"
          ></user-action-status-chip>
        </td>
        <td class="text-xs-right action-cell">
          <v-btn flat icon color="primary" @click="$emit('show-timeline', props.item)">
            <v-icon>mdi-timeline-clock-outline</v-icon>
          </v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment';
import UserActionStatusChip from './UserActionStatusChip.vue';

export default {
  name: 'UserActionsTable',
  components: { UserActionStatusChip },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      internalPagination: Object.assign({}, this.pagination),
      headers: [
        { text: 'Usuario', value: 'name', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Roles', value: 'roles', sortable: false },
        { text: 'Empresas', value: 'companies', sortable: false },
        { text: 'Fecha alta', value: 'created_at', sortable: false },
        { text: 'Onboarding', value: 'progress_onboarding', sortable: false },
        { text: 'Estado', value: 'status', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'right' },
      ],
    };
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '-';
    },
    companiesText(companies) {
      return companies && companies.length ? companies.join(', ') : '-';
    },
    roleLabel(role) {
      const labels = {
        admin: 'Admin',
        autonomous: 'Autónomo',
        consultant: 'Asesores',
        pyme: 'Pyme',
        superadmin: 'Super Admin',
      };
      return labels[role] || role;
    },
  },
  watch: {
    pagination: {
      deep: true,
      handler(value) {
        if (JSON.stringify(value) !== JSON.stringify(this.internalPagination)) {
          this.internalPagination = Object.assign({}, value);
        }
      },
    },
    internalPagination: {
      deep: true,
      handler(value) {
        this.$emit('update:pagination', Object.assign({}, value));
      },
    },
  },
};
</script>

<style scoped>
.progress-cell {
  min-width: 120px;
}

.action-cell {
  white-space: nowrap;
}

.user-actions-table >>> .v-progress-linear {
  margin: 0;
}
</style>
